<script>
    // component options  ------------------------------------------------------ //
    export let id;
    export let label;
    export let value;
    export let disabled = false;


    // internal variables ------------------------------------------------------ //
    const field_id = `field-${id}`;
</script>


<style>
    .checkbox-label {
        color: dimgray;
        text-align: left;
        margin-top: -16px;
        font-size: 0.8rem;
        font-weight: 400;
        letter-spacing: .009375em;
        line-height: 1.1rem;
    }

    .mdc-checkbox__background {
        top: 2px;
    }
</style>


<div id={field_id}
     class="mdc-form-field">
    <div id={id}
         class="mdc-checkbox">
        <input type="checkbox"
               class="mdc-checkbox__native-control"
               id={"check-" + id}
               disabled={disabled}
               bind:checked={value} />

        <div class="mdc-checkbox__background">
            <svg class="mdc-checkbox__checkmark"
                 viewBox="0 0 24 24">
                <path class="mdc-checkbox__checkmark-path"
                      fill="none"
                      d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
            </svg>

            <div class="mdc-checkbox__mixedmark"></div>
        </div>
    </div>

    <label class="checkbox-label" style="text-align: left; cursor: pointer;"  on:click={() => value = !value}
           for={id}>{@html label}</label>
</div>
